export { default } from "./PartnerTile";
export * from "./PartnerTile";
